// Shared vocabulary word-list validation — used by both CustomListNewPage and
// CustomListEditPage so teachers see identical validation feedback regardless
// of which page triggered it.

export const WORD_MAX = 30;
export const DEF_MAX = 100;

// `words` must already be filtered to non-blank { word, definition } pairs.
// Returns { errors, warnings } — warnings are only ever populated when
// errors is empty (they're advisory guidance, not blocking).
export function validateWordList(listName, words) {
  const errors = [];
  const warnings = [];

  if (!listName.trim()) errors.push('Please give your list a name.');
  if (words.length < 25) {
    errors.push(`Need at least 25 word/definition pairs to save (enough for a 4×4 game) — you have ${words.length}.`);
  }

  const seen = new Set();
  for (const { word, definition } of words) {
    const w = word.trim();
    const d = definition.trim();
    if (w.length > WORD_MAX) {
      errors.push(`Word too long (${w.length} chars): "${w.slice(0, 20)}…" — limit is ${WORD_MAX} characters.`);
    }
    if (d.length > DEF_MAX) {
      errors.push(`Definition too long for "${w}" (${d.length} chars) — limit is ${DEF_MAX} characters.`);
    }
    const key = w.toLowerCase();
    if (seen.has(key)) errors.push(`Duplicate word: "${w}" — each word must appear only once.`);
    seen.add(key);
  }

  if (errors.length === 0) {
    // Non-blocking warnings
    if (words.length < 40) {
      warnings.push(`${words.length} words — enough for a 4×4 game, but need 40+ for a 5×5 game.`);
    }
  }

  return { errors, warnings };
}
